import React, { useState } from "react";
import { Form, Input, Button, Select, Row, Col, message, DatePicker, Checkbox, Upload, Typography } from "antd";
import { UploadOutlined, InfoCircleOutlined, DeleteOutlined, ExclamationCircleOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useHistory } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import _NewapplicationService from "../../modules/NewapplicationService";
import { APPLICATION_SUBMIT_SUCCESSFULLY, SUBMISSION_FAILED, FILE_SIZE_VALIDATION, FILE_TYPE_VALIDATION } from "../../constants/constants";
import { routes } from "../../routes/Routes";

const { Option } = Select;
const { Title, Text } = Typography;
const fileFormatText = (
    <Text type="secondary" style={{ fontSize: 12 }}>
        Format: png, jpeg &nbsp; &nbsp; Size: 155k-350k
    </Text>
);

const ApplicantProfessionalDetails = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);
    const [imagePath, setImagePath] = useState(undefined);
    const [imagePathValue, setImagePathValue] = useState(undefined);
    const [file, setFile] = useState({});

    const removeFile = () => {
        setFile({});
        setImagePath(undefined);
        setImagePathValue(undefined);
    };

    const preventRequest = (file) => {
        // let isValidFileDm = _commonService.getImageDimensions(file);
        if (
            file &&
            file.type &&
            file.type.toLowerCase().includes("image") &&
            file.size <= 10000000
        ) {
            setFile(file);
            setImagePathValue("test");
            return false;
        } else {
            setFile(undefined);
            setImagePathValue(undefined);
            if (!(file && file.type && file.type.toLowerCase().includes("image"))) {
                message.error(FILE_TYPE_VALIDATION);
            } else if (file && file.size > 10000000) {
                message.error(FILE_SIZE_VALIDATION);
                // }else if(!isValidFileDm){
                //   message.error(FILE_DIMENTION_VALIDATION);
            }
            return Upload.LIST_IGNORE;
        }
    };

    const onFinish = async (values) => {
        history.push(routes.uploaddocuments.path);
        // setLoading(true);
        // let reqObj = {
        //     employmentType: values.employmentType,
        //     employmesName: values.employmesName,
        //     contactNumber: values.contactNumber,
        //     companyAddress: values.companyAddress,
        //     city: values.city,
        //     state: values.state,
        //     zipCode: values.zipCode,
        //     jobRole: values.jobRole,
        //     numbersOfYears: values.numbersOfYears,
        //     typeOfBusiness: values.typeOfBusiness,

        // }
        // try {
        //     const res = await _NewapplicationService.submitApplicantDetails(reqObj);
        //     if (res.data.isSuccess) {
        //         setLoading(false);
        //         message.success(APPLICATION_SUBMIT_SUCCESSFULLY);
        //         //  history.push("/verifyotp");
        //     }
        // } catch (err) {
        //     setLoading(false);
        //     message.error(err.message || SUBMISSION_FAILED);
        // }
        // finally {
        //     setLoading(false);
        // }

    };

    const onBack = () => {
        history.push(routes.identificationOfcoBorrower.path);
    }

    return (
        <LeftLayout>
            <Row className="rightbox">
                <Col span={24}>
                    <Title level={3} style={{ marginTop: 25, marginBottom: 30 }}>Applicants Professional Details</Title>
                    <Form
                        layout="vertical"
                        onFinish={onFinish}
                        initialValues={{ applicationType: undefined }}
                    >
                        <Form.Item
                            label="Employment Type"
                            name="applicationType"
                            className='w50'
                            rules={[{ required: true, message: "Please select application type" }]}
                        >
                            <Select placeholder="Select">
                                <Option value="personal">Us Passward</Option>
                                <Option value="business">ID Number</Option>
                                {/* Add more types as needed */}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="Employmers Name/Business Name"
                            name="employmers_Name"
                            className='w50'
                        //rules={[{ required: true, message: "Employmers Name/Business Name is required" },]}
                        >
                            <Input maxLength={20} />
                        </Form.Item>

                        <Form.Item
                            label="Business Contact Number"
                            name="contactNumber"
                            className='w50'
                        // rules={[{ required: true, message: "Business Contact Number is required" },]}
                        >
                            <Input maxLength={20} />
                        </Form.Item>

                        <Form.Item
                            label="Company Address (Street Address,P.O Box)"
                            name="address"
                            className='w50'
                        // rules={[{ required: true, message: "Address is required" },]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="City"
                            name="city"
                            className='w50'
                        //rules={[{ required: true, message: "City is required" },]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="State"
                            name="state"
                            className='w50'
                        // rules={[{ required: true, message: "State is required" },]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Zip Code"
                            name="zipcode"
                            className='w50'
                            rules={[
                                { required: true, message: "Zip Code is required" },
                                {
                                    pattern: /^\d{5}(-\d{4})?$/,
                                    message: "Enter a valid ZIP Code (e.g., 12345 or 12345-6789)",
                                },
                            ]}
                        >
                            <Input maxLength={10} />
                        </Form.Item>

                        <Form.Item
                            label="Job Role/Position/Title"
                            name="jobRole"
                            className='w50'
                        // rules={[{ required: true, message: "Job Role/Position/Title is required" },]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="No. Of Years"
                            name="numbersOfYears"
                            className='w50'
                        // rules={[{ required: true, message: "No.Of Years is required" },]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Type Of Business"
                            name="typeOfBusiness"
                            className='w50'
                        //rules={[{ required: true, message: "Job Role/Position/Title is required" },]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item>
                            <div style={{ display: "flex", gap: 16 }}>
                                <Button
                                    onClick={onBack}
                                    icon={<LeftOutlined />}
                                >
                                    Go Back
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                >
                                    Save And Proceed <RightOutlined />
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </LeftLayout>
    );
};

export default ApplicantProfessionalDetails;